import Vue from 'vue';
import VueGtagPlugin from 'vue-gtag';
import App from './App.vue';
import router from './router';
import { store } from './store';
import './polyfills';
import DialogPlugin from './plugins/dialog';
import * as Locale from '@/plugins/i18n';
import * as PleasedApi from '@/common/api/api.pleased';
import '@/vendor/baguetteBox-js/baguetteBox.min.css';
import { createPinia, PiniaVuePlugin } from 'pinia';
import { VueQueryPlugin } from '@tanstack/vue-query';

Vue.config.productionTip = false;
Vue.use(PiniaVuePlugin);
Vue.use(VueQueryPlugin);
Vue.use(DialogPlugin);
Vue.use(VueGtagPlugin, {
  bootstrap: false,
  appName: 'Pleased',
  pageTrackerScreenviewEnabled: true,
}, router);

const pinia = createPinia();

window.VMPY = new Vue({
  router,
  store,
  render: h => h(App),
  i18n: Locale.i18n,
  pinia,
}).$mount('#app');

// this is for $dialog
window.h = window.VMPY.$createElement;

// Set header for pleased API when language changes.
Locale.addListener(({ current: acceptLanguage }) => PleasedApi.setConfig({ acceptLanguage }), true);
